import React, { useEffect, useState, Suspense, lazy } from "react";

// import Form from "./../form";
// import Spinner from "./../LazySpinner/spinner";

import Header from "./../Header";
import Footer from "./../Footer";

import Login from "./../SignIn/login";
import Signup from "./../SignUp/signup";
import Sitehome from "./../LandingPage/Sitehome";

import Verifyemail from "./../VerifyEmail/verifyemail";

import VerifyTockenMail from "./../ForgotPass/VerifyTockenMail";

import Forgetpass from "./../ForgotPass/Forgetpass";

import Newpass from "./../ForgotPass/Newpass";

import Notfound from "./../PageNotFound/pagenotfound";

import { useSelector } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";

import History from "./../History/history";

import PrivateRoute from "./../Routes/PrivateRoutes/PrivateRoutes";

import PublicRoute from "../Routes/PublicRoutes/PublicRoute";
// import PageNotFound from "../PageNotFound/PageNotFound";
// const state = useSelector((state)=> state.LoginAdmin.)

// import Progressbar from "../Login/progressbar";

const AllRoutes = () => {
  // const Form = lazy(() => import("../form.js"));

  return (
    <div>
      {/* <Suspense fallback={<Spinner />}> */}
      <Router history={History} forceRefresh={true}>
        <Switch>
          <PublicRoute path="/" component={Sitehome} exact={true} />
          <PublicRoute path="/signup" component={Signup} exact={true} />
          <PublicRoute path="/login" component={Login} exact={true} />
          <PublicRoute path="/Forgetpass" component={Forgetpass} exact={true} />
          <PublicRoute path="/Newpass" component={Newpass} exact={true} />
          <PublicRoute
            path="/verifyemail"
            component={Verifyemail}
            exact={true}
          />

          <PublicRoute
            path="/VerifyTockenMail"
            component={VerifyTockenMail}
            exact={true}
          />
        </Switch>
        <Footer />
      </Router>
      {/* </Suspense> */}
    </div>
  );
};

export default AllRoutes;
